module.exports = __webpack_public_path__ + "img/33600.0c9daa66.jpg";